import { useState } from 'react';

import { Add } from '@mui/icons-material';
import { Box, Button, Typography } from '@mui/material';

import { DreConfigConfiguracoesModal } from 'pages/financeiro/dre/configuracao/components';
import { useDreConfigConfiguracoesContext } from 'pages/financeiro/dre/configuracao/contexts/DreConfigConfiguracoesContext';

export function DreConfigConfiguracoesTitle() {
    const { isFetchingConfiguracoes } = useDreConfigConfiguracoesContext();
    const [openConfiguracaoModal, setOpenConfiguracaoModal] = useState(false);

    return (
        <>
            <DreConfigConfiguracoesModal open={openConfiguracaoModal} setOpen={setOpenConfiguracaoModal} />

            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: 28 }}>
                <Typography sx={{ color: 'secondary.main', fontSize: 16 }}>Configurações</Typography>

                {!isFetchingConfiguracoes && (
                    <Button size="small" variant="text" startIcon={<Add />} onClick={() => setOpenConfiguracaoModal(true)}>
                        Adicionar configuração
                    </Button>
                )}
            </Box>
        </>
    );
}
